import fetch from 'isomorphic-fetch'
import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { setContext } from '@apollo/client/link/context'
import { store } from '../redux'
import config from '../../config'

const API_URL = config.api.storeadmin
const OBSERVER_API_URL = config.api.observer

const retryLink = new RetryLink()

const httpLink = new HttpLink({
  fetch,
  credentials: 'include',
})

// 認証情報がオブザーバーの時はオブザーバー用のエンドポイントを使う
const authLink = setContext((_, { headers }) => {
  const {
    auth: { accessToken, organizationName },
  } = store.getState()

  return organizationName !== 'saga-observer'
    ? {
        uri: `${API_URL}/${organizationName}/graphql`,
        headers: {
          ...headers,
          authorization: `Bearer ${accessToken}`,
        },
      }
    : {
        uri: `${OBSERVER_API_URL}`,
        headers: {
          ...headers,
          authorization: `Bearer ${accessToken}`,
        },
      }
})

const additiveLink = from([retryLink, authLink.concat(httpLink)])

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      ArenaBookingInfo: {
        keyFields: false,
      },
      OrderLineItem: {
        fields: {
          arenaBookingInfo: {
            merge: false,
          },
        },
      },
    },
  }),
  link: additiveLink,
})

export default client
